import React from 'react';
import MaintenanceModal from 'src/Components/MaintenanceModal';
import WalletConnectConfirmProvider from 'src/Components/WalletConnectConfirmProvider';
import { ModalName } from './config';

const noop = () => {};

const PopupContext = /*#__PURE__*/React.createContext({
  openModal: noop,
  closeModal: noop,
  openMaintenance: noop
});

const PopupProvider = ({
  children
}) => {
  const [modal, setModal] = React.useState(null);
  const openMaintenance = React.useCallback(() => {
    setModal(ModalName.MAINTENANCE_STAKING);
  }, []);
  const openModal = React.useCallback(modal => {
    setModal(modal);
  }, []);
  const closeModal = React.useCallback(() => {
    setModal(null);
  }, []);
  const context = React.useMemo(() => {
    return {
      modal: modal || undefined,
      openModal,
      closeModal,
      openMaintenance
    };
  }, [closeModal, modal, openMaintenance, openModal]); // Render the current modal

  const renderModal = () => {
    switch (modal) {
      case ModalName.MAINTENANCE_STAKING:
        return /*#__PURE__*/React.createElement(MaintenanceModal, {
          onClose: () => {
            closeModal();
          }
        });

      default:
        return null;
    }
  };

  return /*#__PURE__*/React.createElement(WalletConnectConfirmProvider, null, /*#__PURE__*/React.createElement(PopupContext.Provider, {
    value: context
  }, children, renderModal()));
};

export const usePopup = () => {
  const {
    modal,
    openMaintenance
  } = React.useContext(PopupContext);
  return {
    modal,
    openMaintenance
  };
};
export default PopupProvider;